"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var _string = require("@insided/deprecated-preact-components/utils/string");

var _eventIcon = _interopRequireDefault(require("@insided/deprecated-control/Event/create-event/assets/eventIcon.png"));

var menuItems = {
  topicCardSmall: {
    label: 'Topic card (small)',
    command: 'topic-card-small',
    group: 'group',
    order: 1
  },
  topicCardLarge: {
    label: 'Topic card (large)',
    command: 'topic-card-large',
    group: 'group',
    order: 1
  }
};
var emailWidgetsPlugin = {
  requires: 'widget',
  init: function init(editor) {
    editor.addMenuGroup('group');
    editor.addMenuItems(menuItems);
    editor.ui.add('EmailWidgets', 'menubutton', {
      label: 'Email widgets',
      hasArrow: true,
      modes: {
        wysiwyg: 1
      },
      panel: {
        css: window.CKEDITOR.config.contentsCss
      },
      onMenu: function onMenu() {
        return menuItems;
      }
    });
    editor.addCommand('topic-card-large', {
      exec: function exec(editor) {
        editor.fire('topicCardClicked', {
          // topic props are destructured here
          onAdd: function onAdd(_ref) {
            var title = _ref.title,
                content = _ref.content,
                featuredImage = _ref.featuredImage,
                url = _ref.url;
            var wrapperElement = editor.document.createElement('div', {
              styles: {
                pointerEvents: 'none'
              }
            });
            wrapperElement.addClass('email-widgets-topic-card-wrapper');

            if (featuredImage) {
              var featuredImageElement = editor.document.createElement('img', {
                attributes: {
                  src: featuredImage,
                  width: '560',
                  height: '250'
                }
              });
              var imageLinkElement = editor.document.createElement('a', {
                attributes: {
                  href: url,
                  target: '_blank'
                },
                styles: {
                  textDecoration: 'none',
                  color: 'inherit'
                }
              });
              imageLinkElement.append(featuredImageElement);
              wrapperElement.append(imageLinkElement);
            }

            var titleElement = editor.document.createElement('h2');
            var titleLinkElement = editor.document.createElement('a', {
              attributes: {
                href: url,
                target: '_blank'
              },
              styles: {
                textDecoration: 'none',
                color: 'inherit'
              }
            });
            titleLinkElement.appendText(title);
            titleElement.append(titleLinkElement);
            wrapperElement.append(titleElement);
            var contentElement = editor.document.createElement('div');
            var contentLinkElement = editor.document.createElement('a', {
              attributes: {
                href: url,
                target: '_blank'
              },
              styles: {
                textDecoration: 'none',
                color: 'inherit'
              }
            });
            contentLinkElement.appendText((0, _string.excerpt)(_htmlParser.default.stripHtml(content), 350));
            contentElement.append(contentLinkElement);
            wrapperElement.append(contentElement);
            editor.insertHtml(wrapperElement.getOuterHtml());
          }
        });
      }
    });
    editor.addCommand('topic-card-small', {
      exec: function exec(editor) {
        editor.fire('topicCardClicked', {
          // topic props are destructured here
          onAdd: function onAdd(_ref2) {
            var title = _ref2.title,
                featuredImage = _ref2.featuredImage,
                contentType = _ref2.contentType,
                startDate = _ref2.startDate,
                type = _ref2.type,
                url = _ref2.url;
            var isEvent = contentType === 'event';
            var date = new Date(startDate * 1000).toLocaleDateString([], {
              weekday: 'short',
              month: 'short',
              day: 'numeric',
              hour: "2-digit",
              minute: "2-digit",
              hour12: false
            });
            var wrapperElement = editor.document.createElement('div', {
              styles: {
                pointerEvents: 'none'
              }
            });
            wrapperElement.addClass('email-widgets-topic-card-wrapper');
            var topicCardElement = editor.document.createElement('div', {
              styles: {
                minHeight: '24px',
                boxSizing: 'border-box',
                borderRadius: '4px',
                border: '1px solid #d5d7db',
                padding: '17px 24px',
                margin: '8px 0',
                backgroundColor: '#fff',
                position: 'relative',
                width: '480px',
                display: 'table'
              }
            });
            var linkToTopicElement = editor.document.createElement('a', {
              attributes: {
                href: url,
                target: '_blank'
              },
              styles: {
                color: 'inherit',
                display: 'inline'
              }
            });

            if (featuredImage || isEvent) {
              var featuredImageWrapper = editor.document.createElement('div', {
                styles: {
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  backgroundColor: isEvent ? '#0069ff' : ''
                }
              });
              var featuredImageElement = editor.document.createElement('img', {
                attributes: {
                  src: isEvent ? _eventIcon.default : featuredImage,
                  width: '24',
                  height: '24'
                },
                styles: {
                  outline: 'none',
                  margin: '0',
                  padding: '0'
                }
              });
              var featuredImageCell = editor.document.createElement('div', {
                styles: {
                  display: 'table-cell',
                  paddingRight: '16px',
                  verticalAlign: 'middle'
                }
              });
              featuredImageWrapper.append(featuredImageElement);
              featuredImageCell.append(featuredImageWrapper);
              topicCardElement.append(featuredImageCell);
            }

            var contentElement = editor.document.createElement('div');
            var titleElement = editor.document.createElement('div', {
              styles: {
                color: '#2b3346',
                fontWeight: '500',
                fontSize: '14px',
                whiteSpace: 'break-spaces'
              }
            });
            titleElement.appendText(title);
            contentElement.append(titleElement);

            if (isEvent) {
              if (type) {
                var labelElement = editor.document.createElement('div', {
                  styles: {
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    background: '#616a73',
                    padding: '4px',
                    color: '#fff',
                    borderRadius: '4px',
                    lineHeight: '1',
                    fontSize: '11px',
                    height: '18px',
                    boxSizing: 'border-box',
                    fontWeight: '400',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginLeft: '8px'
                  }
                });
                labelElement.appendText(type);
                titleElement.append(labelElement);
              }

              var dateElement = editor.document.createElement('div', {
                styles: {
                  paddingLeft: '16px',
                  color: '#a7aeb5',
                  fontSize: '14px',
                  display: 'inline'
                }
              });
              dateElement.appendText(date);
              titleElement.append(dateElement);
            }

            var contentElementCell = editor.document.createElement('div', {
              styles: {
                display: 'table-cell',
                verticalAlign: 'middle',
                width: '99%'
              }
            });
            contentElementCell.append(contentElement);
            topicCardElement.append(contentElementCell);
            linkToTopicElement.append(topicCardElement);
            wrapperElement.append(linkToTopicElement);
            editor.insertHtml(wrapperElement.getOuterHtml());
          }
        });
      }
    });
    editor.widgets.add('email-widget', {
      upcast: function upcast(element) {
        return element.name === 'div' && element.hasClass('email-widgets-topic-card-wrapper');
      }
    });
  }
};
var _default = emailWidgetsPlugin;
exports.default = _default;